import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import MarketingShell from "./MarketingShell";
import { Button } from "@/components/ui/button";
import { CalendarClock, Clock, Globe2, MailCheck, Users, LineChart, ListChecks, Layers, MousePointer2 } from "lucide-react";

export default function Features() {
    const { t } = useI18n();
    const nav = useNavigate();
    const items = [
        { icon: CalendarClock, t: "marketing.f1t", d: "marketing.f1d" },
        { icon: Clock, t: "marketing.f2t", d: "marketing.f2d" },
        { icon: Layers, t: "marketing.f5t", d: "marketing.f5d" },
        { icon: ListChecks, t: "marketing.f7t", d: "marketing.f7d" },
        { icon: MousePointer2, t: "marketing.f8t", d: "marketing.f8d" },
        { icon: Globe2, t: "marketing.f3t", d: "marketing.f3d" },
        { icon: MailCheck, t: "marketing.f4t", d: "marketing.f4d" },
        { icon: Users, t: "marketing.f9t", d: "marketing.f9d" },
        { icon: LineChart, t: "marketing.f6t", d: "marketing.f6d" },
    ];
    return (
        <MarketingShell>
            <section className="mx-auto max-w-7xl px-6 py-16 md:py-24">
                <div className="max-w-2xl">
                    <h1 className="font-serif text-4xl font-bold tracking-tighter md:text-5xl">{t("marketing.featuresTitle")}</h1>
                    <p className="mt-4 text-lg text-muted-foreground">{t("marketing.featuresSub")}</p>
                </div>
                <img src="https://images.unsplash.com/photo-1700760934268-8aa0ef52ce0a" alt="Stylist"
                    className="mt-10 h-72 w-full rounded-3xl object-cover md:h-96" />
                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {items.map((f, i) => (
                        <div key={i} className="rounded-2xl border border-border/70 bg-card p-7 transition-transform duration-200 hover:-translate-y-1">
                            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/12 text-accent"><f.icon className="h-5 w-5" /></div>
                            <h3 className="mt-4 font-semibold">{t(f.t)}</h3>
                            <p className="mt-2 text-sm text-muted-foreground">{t(f.d)}</p>
                        </div>
                    ))}
                </div>
                <div className="mt-14 text-center">
                    <Button size="lg" onClick={() => nav("/register")} className="rounded-full px-8">{t("common.startTrial")}</Button>
                </div>
            </section>
        </MarketingShell>
    );
}
